// Plain calendar-date helpers. Dates here are "2026-10-18" strings (no time zones to trip over).

/** "2026-10-18" plus some days (negative goes back) */
export function addDays(iso: string, days: number): string {
  const d = new Date(iso + 'T00:00:00Z');
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
}

/** How many days from `from` to `to` (negative if `to` is earlier) */
export const daysBetween = (from: string, to: string) => Math.round((Date.parse(to) - Date.parse(from)) / 86_400_000);

/** The Sunday on or before this date: where its week starts */
export function weekStart(iso: string): string {
  return addDays(iso, -new Date(iso + 'T00:00:00Z').getUTCDay());
}

/** The first day of the date's month */
export const monthStart = (iso: string) => iso.slice(0, 8) + '01';

/** The date moved by whole months */
export function addMonths(iso: string, months: number): string {
  const d = new Date(iso + 'T00:00:00Z');
  d.setUTCDate(1);
  d.setUTCMonth(d.getUTCMonth() + months);
  return d.toISOString().slice(0, 10);
}

/** All the days a month calendar shows: whole weeks, Sunday first */
export function monthGrid(iso: string): string[][] {
  const first = monthStart(iso);
  const start = weekStart(first);
  const month = first.slice(0, 7);
  const weeks: string[][] = [];
  for (let day = start; ; day = addDays(day, 7)) {
    if (day.slice(0, 7) > month && weeks.length >= 4) break;
    weeks.push(Array.from({ length: 7 }, (_v, i) => addDays(day, i)));
    if (weeks.length === 6) break;
  }
  return weeks;
}

/** "July 2025" */
export const monthTitle = (iso: string) =>
  new Date(iso + 'T00:00:00Z').toLocaleDateString('en-GB', { month: 'long', year: 'numeric', timeZone: 'UTC' });

/** "Wed, 23 Jul 2025" */
export const longDate = (iso: string) =>
  new Date(iso + 'T00:00:00Z').toLocaleDateString('en-GB', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  });

/** 2026-10-18 → 18/10/2026 */
export const dmy = (iso: string) => iso.split('-').reverse().join('/');

export { shortDate } from '@serb/shared';
